export const state = {
  max_inv_logins: 0,
  expiration: 0,
  history: 0,
  min_len: 8,
  max_len: 16,
  min_special: 0,
  min_upper: 0,
  min_lower: 0,
  max_length_string: 1024,
  loading: true,
  error: {
    status: false,
    message: null
  },
  usr_name_max_len: 16,
  key_name_max_len: 32,
  usr_name_min_len: 1,
  key_name_min_len: 1
}

export const getters = {}

export const mutations = {
  SET_MAX_INV_LOGINS (state, payload = 0) {
    state.max_inv_logins = payload
  },
  SET_EXPIRATION (state, payload = 0) {
    state.expiration = payload
  },
  SET_HISTORY (state, payload = 0) {
    state.history = payload
  },
  SET_MIN_LEN (state, payload = 8) {
    state.min_len = payload
  },
  SET_MIN_SPECIAL (state, payload = 0) {
    state.min_special = payload
  },
  SET_MIN_UPPER (state, payload = 0) {
    state.min_upper = payload
  },
  SET_MIN_LOWER (state, payload = 0) {
    state.min_lower = payload
  }
}

export const actions = {
  async getPwdSecPolicy ({ commit, rootState, dispatch }) {
    try {
      const res = await rootState.hsm.instance.getPwdSecPolicy()
      commit('SET_MAX_INV_LOGINS', res.max_inv_logins)
      commit('SET_EXPIRATION', res.expiration)
      commit('SET_MIN_LEN', res.min_len)
      commit('SET_MIN_SPECIAL', res.min_special)
      commit('SET_MIN_UPPER', res.min_upper)
      commit('SET_MIN_LOWER', res.min_lower)
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async setPwdSecPolicy ({ state, dispatch, rootState }) {
    const body = {
      max_inv_logins: state.max_inv_logins,
      expiration: state.expiration,
      min_len: state.min_len,
      min_special: state.min_special,
      min_upper: state.min_upper,
      min_lower: state.min_lower
    }

    try {
      await rootState.hsm.instance.setPwdSecPolicy({ body })
      dispatch('getPwdSecPolicy')
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  }
}
